import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=07885d52&scoped=true&"
var script = {}
import style0 from "./serve.vue?vue&type=style&index=0&id=07885d52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07885d52",
  null
  
)

export default component.exports